import { createApp } from 'vue'

//element-plus
import './assets/css/element/index.scss'
import 'element-plus/theme-chalk/display.css'
import ElementPlus from 'element-plus'
import locale from 'element-plus/lib/locale/lang/zh-cn'

//video
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
import hls from 'videojs-contrib-hls' // 播放hls流需要的插件

import App from './App.vue'
import router from './router'
import store from './store'

//mock
// import '../mock/index'

//全局样式
import './assets/css/index.scss'
import './assets/css/element/cpn.scss'

//水印指令
import watermark from './directives/watermark.js'

const app = createApp(App)

app.use(vue3videoPlay)
app.use(hls)

app.directive(watermark.name, watermark.fn)

app.use(ElementPlus, { locale }).use(store).use(router).mount('#app')
